import React from 'react';

interface LogoProps {
  size?: 'small' | 'medium' | 'large';
  showText?: boolean;
  className?: string;
  variant?: 'default' | 'white' | 'light' | 'dark';
}

const Logo: React.FC<LogoProps> = ({ 
  size = 'medium', 
  showText = false, 
  className = '', 
  variant = 'default' 
}) => {
  const getSizeClass = () => {
    switch (size) {
      case 'small':
        return 'logo-small';
      case 'large':
        return 'logo-large';
      default:
        return 'logo-medium';
    }
  };

  const getLogoSrc = () => {
    switch (variant) {
      case 'white':
      case 'light':
        return '/images/axiomteq-logo-light.png';
      case 'dark':
        return '/images/axiomteq-logo-dark.png';
      default:
        // Default to light logo for better contrast on dark backgrounds
        return '/images/axiomteq-logo-light.png';
    }
  };

  return (
    <div className={`logo-container ${getSizeClass()} ${className}`}>
      <img 
        src={getLogoSrc()} 
        alt="Axiomteq Logo" 
        className="logo-image"
        onError={(e) => {
          // Fallback to the other logo variant if current one fails, but only once
          const target = e.target as HTMLImageElement;
          if (!target.dataset.fallbackAttempted) {
            target.dataset.fallbackAttempted = 'true';
            const currentSrc = target.src;
            if (currentSrc.includes('light')) {
              target.src = "/images/axiomteq-logo-dark.png";
            } else {
              target.src = "/images/axiomteq-logo-light.png";
            }
          }
        }}
      />
      {showText && <span className="logo-text">Axiomteq</span>}
    </div>
  );
};

export default Logo; 